import React from 'react'

const ErrorMessages = ({
  invalidRangeOffset,
  invalidRangeLimit,
  invalidRangeFormat,
  invalidDateFormat
}) => (
  <>
    {invalidRangeOffset && (
      <div className="alert alert-danger">
        <strong>
          ERROR: No se pueden seleccionar fechas posteriores a hoy. Por favor escoger otra
          fecha.
        </strong>
      </div>
    )}
    {invalidRangeLimit && (
      <div className="alert alert-danger">
        <strong>
          ERROR: Rango de fechas escogidas pasan de los 12 meses. Por favor escoger otra fecha.
        </strong>
      </div>
    )}
    {invalidRangeFormat && (
      <div className="alert alert-danger">
        <strong>ERROR: Fecha de inicio debe de ser antes que la fecha de fin.</strong>
      </div>
    )}
    {invalidDateFormat && (
      <div className="alert alert-danger">
        <strong>ERROR: Formato de fecha inválido. Por favor verifique que las fechas están escritas
          correctamente.</strong>
      </div>
    )}
  </>
)

export default ErrorMessages
